import {Load} from "./Load";
import {History} from "./History";

export class Overlay
{
    static close(url)
    {
        const overlay = document.getElementById('w--overlay');
        if(overlay)
        {
            overlay.classList.add('mod--off');
            History.push_url(url.split('#')[0], Overlay.remTitle);
            setTimeout(() => {
                document.documentElement.classList.remove('mod--overlay');
                overlay.remove();
            },750);
        }
    }

    static async open(url, f)
    {
        const overlay = document.getElementById('w--overlay');
        if(overlay)
        {
            overlay.remove();
        }

        try
        {
            Overlay.remTitle = document.title;

            const r = await Load.fetch({
                url: url,
                f: f
            });

            History.push_url(url, r['pageTitle']);

            document.documentElement.classList.add('mod--overlay');
            document.body.insertAdjacentHTML('afterbegin', r['html']);
            const overlay = document.getElementById('w--overlay');
            overlay.offsetHeight;
            overlay.classList.remove('mod--off');
        }
        catch(error) {}
    }
}

